export interface Party {
  name: string;
  role: string;
  stance: string;
  quote: string;
  points: string[];
  reliability: number;
}

export interface TimelineItem {
  date: string;
  title: string;
  desc: string;
}

export interface Followup {
  title: string;
  desc: string;
}

export interface Topic {
  id: string;
  title: string;
  category: string;
  tags: string[];
  heat: number;
  date: string;
  status: string;
  cover: string;
  summary: string;
  parties: Party[];
  timeline: TimelineItem[];
  followups: Followup[];
  sourceCount: number;
  readingMinutes: number;
}

export const categories = [
  "全部",
  "带货风波",
  "直播争议",
  "情感纠葛",
  "品牌翻车",
  "人设崩塌",
  "团队内讧",
];

export const topics: Topic[] = [
  {
    id: "peach-refund",
    title: "甜妹小桃直播间退款风波：128 单未发货，团队称「系统故障」",
    category: "带货风波",
    tags: ["直播带货", "退款难", "粉丝维权"],
    heat: 9821,
    date: "2026-09-08",
    status: "持续发酵",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20overlapping%20speech%20bubbles%20in%20coral%20red%20and%20cream%20beige%2C%20soft%20geometric%20shapes%2C%20torn%20paper%20fragments%2C%20minimalist%20magazine%20cover%20style%2C%20clean%20flat%20layout%20on%20warm%20neutral%20background%2C%20high%20detail&width=800&height=500&seq=gossip-peach-cover&orientation=landscape",
    summary:
      "9 月 5 日晚的周年庆专场直播中，主播甜妹小桃承诺「当晚下单 48 小时内发货」，但截至 9 月 8 日，至少 128 位买家表示订单仍停留在「已付款」状态。消费者代表随后在社交平台放出客服聊天截图，团队则回应称是「仓储系统升级导致的批量卡单」，双方各执一词。",
    parties: [
      {
        name: "消费者代表「小圆」",
        role: "爆料方",
        stance: "质疑",
        quote:
          "我们不是要退一单两单，是要一个明确时间。客服前后给了三个版本，最早说 48 小时，后来又说七天，再后来直接不回了。",
        points: [
          "晒出 128 单的订单编号与付款凭证，最早一笔付款时间为 9 月 5 日 22:14。",
          "指客服在 9 月 6 日回复「已优先安排」，9 月 7 日改口为「仓库盘点」，口径不一致。",
          "强调核心诉求是统一发货时间表，而非单纯退款。",
        ],
        reliability: 82,
      },
      {
        name: "甜妹小桃工作室",
        role: "当事人",
        stance: "回应",
        quote:
          "订单确实卡在仓库侧，我们已经加派两组人手工出单，9 月 10 日 24 点前全部发出，超时的按订单金额 10% 补偿。",
        points: [
          "承认「48 小时发货」的承诺未按约定执行，解释为合作仓系统升级。",
          "公布补偿方案：超时订单赠送 10% 无门槛券，退货免运费。",
          "未解释为何客服口径在两天内变化三次。",
        ],
        reliability: 64,
      },
      {
        name: "平台电商治理组",
        role: "平台方",
        stance: "介入",
        quote:
          "已对该直播间启动延时发货专项核查，核查期间将限制其参与平台大促活动。",
        points: [
          "确认收到 40 余条相关投诉，已归集为同一事件处理。",
          "要求商家在 3 个工作日内提交仓储与发货记录。",
          "按平台规则，延时发货成立将扣减店铺服务分。",
        ],
        reliability: 90,
      },
      {
        name: "同场助播「阿满」",
        role: "旁观者",
        stance: "补位",
        quote:
          "当晚我在场，专场是提前备货的，但后半场库存被临时调走了一批，具体调去哪儿我不清楚。",
        points: [
          "证实当晚存在库存临时调拨的说法。",
          "表示自己只负责讲解，不参与库存决策。",
          "未提供调拨单据或聊天记录。",
        ],
        reliability: 48,
      },
    ],
    timeline: [
      { date: "09-05 22:14", title: "首批订单付款", desc: "周年庆专场开播，承诺 48 小时内发货。" },
      { date: "09-06 15:30", title: "客服首次回复", desc: "称订单「已优先安排」，请耐心等待。" },
      { date: "09-07 11:02", title: "口径变化", desc: "客服改称仓库盘点，预计延迟 3 至 5 天。" },
      { date: "09-08 09:40", title: "消费者集体发声", desc: "消费者代表整理 128 单证据公开发布。" },
      { date: "09-08 20:15", title: "工作室发布声明", desc: "公布补偿方案并承诺 9 月 10 日前发完。" },
      { date: "09-09 10:00", title: "平台介入核查", desc: "平台启动延时发货专项核查。" },
    ],
    followups: [
      { title: "9 月 9 日：首批 37 单显示已揽收", desc: "物流信息更新，但仍有 91 单显示待发货。" },
      { title: "9 月 9 日晚：补偿券已陆续到账", desc: "部分买家确认收到 10% 无门槛券。" },
    ],
    sourceCount: 6,
    readingMinutes: 6,
  },
  {
    id: "travel-akai",
    title: "旅行博主阿凯直播对质：剪辑争议与行程实拍到底谁在说谎",
    category: "直播争议",
    tags: ["对质现场", "剪辑争议", "行程实拍"],
    heat: 8640,
    date: "2026-09-06",
    status: "已对质",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20a%20camera%20viewfinder%20frame%20and%20map%20pin%20shapes%20in%20amber%20gold%20and%20warm%20coral%2C%20layered%20paper%20cut%20style%2C%20minimalist%20magazine%20layout%20on%20cream%20beige%20background%2C%20soft%20shadows%2C%20high%20detail&width=800&height=500&seq=gossip-travel-cover&orientation=landscape",
    summary:
      "旅行博主阿凯的南美系列视频被前合作摄像师指出「同一场景跨越三天拍摄，剪辑成同一天」，阿凯随即开直播对质。整个对质过程被网友逐帧拆解，双方在「拍摄日期是否存在误导」这一问题上始终没有对齐定义。",
    parties: [
      {
        name: "前合作摄像师「老周」",
        role: "爆料方",
        stance: "质疑",
        quote:
          "我没有说视频造假，我说的是标题写着「一天走完」，实际素材横跨三天，观众会产生误解。",
        points: [
          "公开原始素材的元数据时间戳，指向三个不同日期。",
          "强调争议点是标题与叙事方式，而非画面真实性。",
          "表示合作期间未签署保密协议，愿意承担法律后果。",
        ],
        reliability: 76,
      },
      {
        name: "旅行博主阿凯",
        role: "当事人",
        stance: "回应",
        quote:
          "旅行视频压时间是常规剪辑手法，我在视频里说过是「这一趟」。把三天的行程剪成一段，不等于说谎。",
        points: [
          "承认素材跨越三天，但认为属于行业常见叙事压缩。",
          "直播中逐条展示行程单据与机票，自证确实到过该地。",
          "未正面回答标题为何使用「一天走完」的表述。",
        ],
        reliability: 58,
      },
      {
        name: "同行程驴友「丸子」",
        role: "旁观者",
        stance: "补位",
        quote:
          "我确实和阿凯同走了那段，第一天到了观景台但没拍到好光线，第二天又去了一次。",
        points: [
          "证实同一地点拍摄了多次。",
          "认为视频呈现的结果与真实行程「差不太多」。",
          "未参与视频剪辑，不了解标题拟定过程。",
        ],
        reliability: 70,
      },
      {
        name: "内容平台合规组",
        role: "平台方",
        stance: "介入",
        quote:
          "该视频不构成虚假信息，但已要求创作者在简介中补充拍摄周期说明。",
        points: [
          "判定视频画面内容真实。",
          "建议补充「非单日拍摄」的说明标签。",
          "不做下架处理。",
        ],
        reliability: 88,
      },
    ],
    timeline: [
      { date: "09-02", title: "摄像师发文", desc: "老周发布素材时间戳比对长文。" },
      { date: "09-03", title: "阿凯首次回应", desc: "发短声明称「无中生有」，未展开细节。" },
      { date: "09-06 20:00", title: "直播对质", desc: "双方连线 96 分钟，围绕「标题是否误导」争执。" },
      { date: "09-06 22:10", title: "对质中断", desc: "阿凯以「信号问题」提前下线。" },
      { date: "09-07", title: "平台判定", desc: "平台要求补充拍摄周期说明。" },
    ],
    followups: [
      { title: "9 月 7 日：视频简介已更新", desc: "新增「素材跨三日拍摄」的说明文字。" },
      { title: "9 月 8 日：老周不再追加证据", desc: "表示「点到为止，不想扩大」。", },
    ],
    sourceCount: 5,
    readingMinutes: 7,
  },
  {
    id: "couple-luyao",
    title: "露遥与子墨情感瓜：两人各给出一条完全不同的时间线",
    category: "情感纠葛",
    tags: ["双方回应", "时间线", "分手原因"],
    heat: 7930,
    date: "2026-09-04",
    status: "各执一词",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20two%20diverging%20timeline%20paths%20in%20dusty%20rose%20and%20cream%20beige%2C%20soft%20geometric%20arcs%2C%20minimalist%20magazine%20style%2C%20clean%20composition%20on%20warm%20neutral%20background%2C%20high%20detail&width=800&height=500&seq=gossip-couple-cover&orientation=landscape",
    summary:
      "约会博主露遥与子墨的「分手时间点」成为争议核心。露遥称两人 6 月已实质分开，子墨则称直到 8 月才得知。两条时间线在 6 月至 8 月之间出现了近两个月的重叠区，成为各方讨论的焦点。",
    parties: [
      {
        name: "露遥",
        role: "当事人 A",
        stance: "回应",
        quote:
          "6 月中旬我们就已经谈开了，只是没公开。公开与否不代表关系没结束。",
        points: [
          "提供 6 月 14 日的长消息截图，内容为「先各自冷静」。",
          "称 7 月仍在同框出镜属于商务合作。",
          "未说明为何 7 月仍共同旅行。",
        ],
        reliability: 62,
      },
      {
        name: "子墨",
        role: "当事人 B",
        stance: "质疑",
        quote:
          "如果 6 月就分了，为什么会一起飞三亚？我是 8 月才从朋友那里知道这件事。",
        points: [
          "公布 7 月共同出行的机票与酒店订单。",
          "强调「冷静期」不等于分手。",
          "承认自己在 8 月前未主动确认关系状态。",
        ],
        reliability: 60,
      },
      {
        name: "共同好友「阿黎」",
        role: "旁观者",
        stance: "补位",
        quote:
          "7 月那趟旅行我看他们状态挺正常的，不像已经分手的人。但具体他们内部怎么谈的，我不在场。",
        points: [
          "认为两人 7 月相处状态正常。",
          "不知道 6 月长消息的内容。",
          "拒绝选边站。",
        ],
        reliability: 55,
      },
      {
        name: "经纪团队",
        role: "关联方",
        stance: "回避",
        quote:
          "艺人私事不便回应，请大家关注作品。",
        points: [
          "对分手时间点不作任何说明。",
          "未否认 7 月旅行的商务性质。",
          "请求外界不要打扰双方家人。",
        ],
        reliability: 30,
      },
    ],
    timeline: [
      { date: "06-14", title: "露遥所称分手节点", desc: "据露遥提供截图，双方互发「先各自冷静」。" },
      { date: "07-02", title: "共同出行", desc: "两人被拍到同赴三亚，子墨称此时关系正常。" },
      { date: "08-05", title: "子墨知悉", desc: "子墨称从朋友处得知关系已结束。" },
      { date: "09-03", title: "双方先后发文", desc: "两条时间线公开，出现近两月重叠区。" },
      { date: "09-04", title: "陷入僵持", desc: "双方均表示「不再补充说明」。" },
    ],
    followups: [
      { title: "9 月 5 日：双方删除部分动态", desc: "两人先后清理了 7 月同框内容。" },
      { title: "9 月 6 日：共同好友发声", desc: "阿黎表示希望外界停止揣测。" },
    ],
    sourceCount: 7,
    readingMinutes: 6,
  },
  {
    id: "brand-fanqi",
    title: "翻车面霜风波：多位博主集中推荐与成分质疑撞在一起",
    category: "品牌翻车",
    tags: ["恰饭", "成分争议", "集中推荐"],
    heat: 7120,
    date: "2026-09-02",
    status: "检测中",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20a%20cosmetic%20dropper%20bottle%20silhouette%20and%20warning%20label%20shapes%20in%20coral%20red%20and%20soft%20cream%2C%20minimalist%20magazine%20style%2C%20clean%20geometric%20composition%20on%20warm%20neutral%20background%2C%20high%20detail&width=800&height=500&seq=gossip-brand-cover&orientation=landscape",
    summary:
      "两周内有 11 位美妆博主先后推荐同一款面霜，随后有用户指出产品备案成分与宣传主打的「核心专利成分」不符。博主们是否属于同一批商业合作，成为讨论重点。",
    parties: [
      {
        name: "成分质疑者「@皮科小陈」",
        role: "爆料方",
        stance: "质疑",
        quote:
          "备案里主打成分排名在防腐剂之后，这个浓度谈「核心专研」不太合适。",
        points: [
          "引用公开备案信息，指出成分排序位置。",
          "质疑宣传语与备案内容存在落差。",
          "已送第三方机构检测，等待报告。",
        ],
        reliability: 74,
      },
      {
        name: "品牌方「QINMO」",
        role: "涉事品牌",
        stance: "回应",
        quote:
          "宣传用语确实存在表述不严谨的地方，我们已下架相关话术，等待检测结果。",
        points: [
          "承认部分宣传表述不够严谨。",
          "下架 3 条争议宣传素材。",
          "否认存在成分造假，等待检测报告。",
        ],
        reliability: 50,
      },
      {
        name: "美妆博主「桐桐」",
        role: "推荐方",
        stance: "回避",
        quote:
          "我接的是品牌单条合作，成分表我当时没逐条核对，这是我的疏忽。",
        points: [
          "承认未核对备案成分表。",
          "表示已删除相关推荐视频。",
          "未说明其他博主是否为同一批合作。",
        ],
        reliability: 66,
      },
      {
        name: "行业观察者「老彭」",
        role: "旁观者",
        stance: "补位",
        quote:
          "11 位博主发布节奏太接近了，大概率是同一波投放，但不代表每个人拿到的品牌口径一样。",
        points: [
          "根据发布时间推断存在集中投放。",
          "强调不能据此认定所有博主知情。",
          "呼吁看检测结果再下结论。",
        ],
        reliability: 68,
      },
    ],
    timeline: [
      { date: "08-20", title: "集中推荐开始", desc: "首位博主发布该面霜推荐内容。" },
      { date: "09-01", title: "成分质疑出现", desc: "备案信息比对内容引发讨论。" },
      { date: "09-02", title: "品牌方回应", desc: "下架争议话术，承认表述不严谨。" },
      { date: "09-03", title: "博主集中删稿", desc: "至少 6 位推荐博主删除相关内容。" },
      { date: "09-05", title: "送检进行中", desc: "第三方检测机构确认已接收样品。" },
    ],
    followups: [
      { title: "9 月 6 日：检测初样进入实验室", desc: "预计 10 个工作日内出具报告。" },
      { title: "9 月 8 日：平台下架商品链接", desc: "该商品在部分平台显示「暂不可购」。" },
    ],
    sourceCount: 9,
    readingMinutes: 5,
  },
  {
    id: "persona-mumu",
    title: "学霸人设木木回应学历质疑：晒出材料却避谈毕业时间",
    category: "人设崩塌",
    tags: ["学历质疑", "人设", "回应避重就轻"],
    heat: 6580,
    date: "2026-08-30",
    status: "存疑",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20a%20graduation%20cap%20shape%20and%20a%20question%20mark%20in%20amber%20gold%20and%20warm%20cream%2C%20minimalist%20magazine%20layout%2C%20clean%20geometric%20composition%20on%20warm%20neutral%20background%2C%20high%20detail&width=800&height=500&seq=gossip-persona-cover&orientation=landscape",
    summary:
      "知识区博主木木长期以「名校背景」作为内容标签。有网友依据其公开活动时间线，质疑其在校时间与工作经历存在重叠，木木随后晒出学生证与成绩单截图，但始终未回应毕业年份这一关键问题。",
    parties: [
      {
        name: "网友考据帖",
        role: "爆料方",
        stance: "质疑",
        quote:
          "我们不是质疑上没上过，是质疑「全日制在读」和「全职创业」这两件事怎么可能同时进行。",
        points: [
          "整理木木公开活动的年份分布。",
          "指出 2023 至 2024 年间存在多重身份重叠。",
          "要求公开毕业年份与学位信息。",
        ],
        reliability: 71,
      },
      {
        name: "博主木木",
        role: "当事人",
        stance: "回应",
        quote:
          "学生证、成绩单都在这里，我没有必要为这件事撒谎。关于毕业时间，属于个人隐私。",
        points: [
          "晒出学生证与成绩单局部截图，关键字段打码。",
          "称毕业时间属于个人隐私不予公开。",
          "未说明创业与在读的时间关系。",
        ],
        reliability: 45,
      },
      {
        name: "同校校友「@理科生阿泽」",
        role: "旁观者",
        stance: "补位",
        quote:
          "学校确实有他这个人。但具体哪一年毕业的，我查不到，学籍信息别人也查不了。",
        points: [
          "确认木木与该校存在关联。",
          "无法核实毕业年份。",
          "认为公开打码的成绩单说服力有限。",
        ],
        reliability: 58,
      },
      {
        name: "MCN 机构",
        role: "关联方",
        stance: "回避",
        quote:
          "艺人的教育背景资料由本人提供，我们未做进一步核验。",
        points: [
          "承认未独立核实学历信息。",
          "表示会与博主沟通后续说明。",
          "未承诺公开说明时间。",
        ],
        reliability: 35,
      },
    ],
    timeline: [
      { date: "08-28", title: "考据帖发布", desc: "网友整理时间线，提出学历质疑。" },
      { date: "08-29", title: "木木首次回应", desc: "发布学生证与成绩单截图。" },
      { date: "08-30", title: "质疑升级", desc: "关键字段打码引发新的讨论。" },
      { date: "09-01", title: "MCN 表态", desc: "承认未核验教育背景。" },
      { date: "09-03", title: "事件降温", desc: "木木暂停更新，未再回应。" },
    ],
    followups: [
      { title: "9 月 4 日：账号暂停更新一周", desc: "主页简介移除了相关背景标签。" },
      { title: "9 月 7 日：粉丝内部出现分歧", desc: "部分粉丝要求给出明确毕业年份。" },
    ],
    sourceCount: 5,
    readingMinutes: 5,
  },
  {
    id: "team-infight",
    title: "三人组解散内幕：前员工爆料与官方声明正面对撞",
    category: "团队内讧",
    tags: ["团队解散", "前员工", "声明对峙"],
    heat: 5890,
    date: "2026-08-27",
    status: "各执一词",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20three%20interlocking%20circles%20breaking%20apart%20in%20coral%20red%20and%20muted%20cream%2C%20minimalist%20magazine%20style%2C%20clean%20geometric%20composition%20on%20warm%20neutral%20background%2C%20high%20detail&width=800&height=500&seq=gossip-team-cover&orientation=landscape",
    summary:
      "搞笑三人组「三条鱼」宣布解散后，一名前员工发文称解散源于分成纠纷。组合发布的官方声明则否认存在经济纠纷，称解散是「创作方向分歧」。两种说法在「是否有欠款」这一点上直接对撞。",
    parties: [
      {
        name: "前员工「小柯」",
        role: "爆料方",
        stance: "质疑",
        quote:
          "2025 年 11 月到 2026 年 3 月的项目分成一直没结，我们催过很多次。",
        points: [
          "提供项目结算表的局部截图。",
          "称多次催款未获书面回复。",
          "强调爆料与解散无直接关联，只是时间接近。",
        ],
        reliability: 67,
      },
      {
        name: "组合「三条鱼」官方",
        role: "当事人",
        stance: "回应",
        quote:
          "解散是创作方向的分歧，不存在任何经济纠纷，相关说法与事实不符。",
        points: [
          "否认存在欠款。",
          "称所有项目款项均已按合同结算。",
          "未提供结算凭证或时间表。",
        ],
        reliability: 44,
      },
      {
        name: "成员之一「大熊」",
        role: "当事人",
        stance: "补位",
        quote:
          "我个人的部分已经结了。团队那部分我不清楚，别问我。",
        points: [
          "确认个人款项已结清。",
          "对团队款项表示不知情。",
          "拒绝评价其他成员。",
        ],
        reliability: 61,
      },
      {
        name: "合作方「星野传媒」",
        role: "关联方",
        stance: "回避",
        quote:
          "项目款已按流程支付给承接主体，后续分配不在我方职责范围内。",
        points: [
          "确认款项已支付给承接主体。",
          "不介入组合内部的分成分配。",
          "未说明承接主体具体是哪一方。",
        ],
        reliability: 63,
      },
    ],
    timeline: [
      { date: "08-25", title: "组合宣布解散", desc: "三条鱼发布解散声明，称方向不同。" },
      { date: "08-26", title: "前员工发文", desc: "小柯称存在未结清的项目分成。" },
      { date: "08-27", title: "官方否认", desc: "组合声明否认经济纠纷。" },
      { date: "08-28", title: "成员表态不一", desc: "大熊称个人部分已结清，团队部分不知情。" },
      { date: "08-30", title: "合作方回应", desc: "星野传媒称款项已支付给承接主体。" },
    ],
    followups: [
      { title: "9 月 1 日：前员工删除部分内容", desc: "小柯删除结算表截图，保留文字说明。" },
      { title: "9 月 2 日：官方未再补充", desc: "组合账号停止更新相关内容。" },
    ],
    sourceCount: 4,
    readingMinutes: 5,
  },
];

export const faqs = [
  {
    q: "「多方说法对比」具体是怎么做的？",
    a: "同一事件我们会把爆料方、当事人、平台方、旁观者的公开说法分别摘出核心观点，按「谁说的、说了什么、回避了什么」并列呈现，而不是只保留单方叙述。对比的是表述口径，不是替谁下结论。",
  },
  {
    q: "为什么同一件事里各方时间线对不上？",
    a: "多数争议的核心就藏在时间线重叠区。我们会在详情页同时呈现各方自述的时间点，标出冲突区间，方便你自己判断哪一方的说法更连贯。",
  },
  {
    q: "你们的结论会不会偏向某一方？",
    a: "站点只做归档和对比，不对当事人做道德评判。每条说法都标注来源数量与信息完整度，判断权留给你。",
  },
  {
    q: "发现事件有新进展怎么办？",
    a: "我们会在详情页的「后续进展」区块按时间追加，旧内容不删除，方便对照同一方前后言行是否一致。",
  },
  {
    q: "热度值代表什么？",
    a: "热度值综合了讨论量、转发量与本页浏览量的相对指数，用于排序参考，并不代表事件的真实性或严重程度。",
  },
];